import React, { useEffect } from "react"
import { connect } from "react-redux"
import { generateBizminerRatios } from "../../../../store/modules/financialRatios/actions";
import YearBar from "../BizminerRatios/YearBar";
import Item from "../BizminerRatios/Item";

function FirstResearchRatios({
  dispatchGenerateBizminerRatios,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateBizminerRatios()
  }, [])

  // Methods
  const handleGenerateBizminerRatios = async () => {
    await dispatchGenerateBizminerRatios()
  }

  return (
    <div>

      <YearBar />

      <Item label = "Current Ratio" tooltip = "Current Assets / Current Liabilities" />
      <Item label = "Quick Ratio" tooltip = "( Cash + Marketable Securities + Accounts Receivable ) / Current Liabilities" />
      <Item label = "Current Liabilities : Net Worth" tooltip = "Current Liabilities / Total Equity" percent = {true} />
      <Item label = "Current Liabilities : Inventory" tooltip = "Current Liabilities / Inventory" percent = {true} />
      <Item label = "Total Liabilities : Net Worth" tooltip = "Total Liabilities / Total Equity" percent = {true} />
      <Item label = "Fixed Assets : Net Worth" tooltip = "Fixed Assets / Total Equity" percent = {true} />
      <Item label = "Days Receivables" tooltip = "( Accounts Receivable / Business Revenue ) × 365" />
      <Item label = "Inventory Turnover" tooltip = "Business Revenue / Inventory" />
      <Item label = "Assets : Business Revenue" tooltip = "Total Assets / Business Revenue" />
      <Item label = "Working Capital to Sales" tooltip = "(Current Assets - Current Liabilities) / Sales" percent = {true} />
      <Item label = "Accounts Payable to Sales" tooltip = "Accounts Payable / Sales" percent = {true} />
      <Item label = "Pre-Tax Return on Business Revenue" tooltip = "Pre-Tax Net Profit / Business Revenue" percent = {true} />
      <Item label = "Pre-Tax Return On Assets" tooltip = "Pre-Tax Net Profit / Total Assets" percent = {true} />
      <Item label = "Pre-Tax Return on Net Worth" tooltip = "Pre-Tax Net Profit / Total Equity" percent = {true} />
      <Item label = "Interest Coverage" tooltip = "EBITDA / Interest Expense" />
      <Item label = "EBITDA : Business Revenue" tooltip = "EBITDA / Business Revenue" percent = {true} />

    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateBizminerRatios() {
    await dispatch(generateBizminerRatios())
  },
})

export default connect(null, mapDispatchToProps)(FirstResearchRatios)
